// artifacts/papacito/src/lib/firstSwipeCopy.ts
//
// Headline copy for the Variant F first-swipe push prompt. Kept in its own
// module with zero runtime imports so it is unit-testable in isolation.

export type SwipeDirection = 'like' | 'pass';

/**
 * Direction-adaptive headline for the first-swipe push opt-in modal.
 * A right-swipe ('like') gets the like-anchored line; a left-swipe ('pass')
 * gets a neutral line so "Like her?" never shows after a rejection.
 */
export function firstSwipePushTitle(direction: SwipeDirection): string {
  return direction === 'like'
    ? 'Like her? Get pinged the second she likes you back.'
    : 'Get pinged the second one of them likes you back.';
}
